import { z } from 'zod/v4';

// Zod v4 Schemas
export const PersonRSVPSchema = z.object({
    name: z.string().min(1, 'Name ist erforderlich').max(100, 'Name zu lang'),
    attendsWedding: z.boolean().default(false),
    attendsPolterabend: z.boolean().default(false),
    attendsNothing: z.boolean().default(false),
    allergies_comments: z.string().max(500, 'Kommentar zu lang').optional(),
    // Polterabend-specific fields (auch für wedding verfügbar)
    brings_items: z.string().max(300, 'Mitbringen-Text zu lang').optional(),
    dietary_requirements: z.string().max(300, 'Diätanforderungen zu lang').optional()
});

export const RSVPSubmissionSchema = z.object({
    email: z.email('Ungültige Email-Adresse'),
    wants_updates: z.boolean().default(true),
    persons: z.array(PersonRSVPSchema).min(1, 'Mindestens eine Person erforderlich').max(10, 'Maximal 10 Personen'),
    additional_notes: z.string().max(1000, 'Notizen zu lang').optional()
});

// TypeScript Types
export type PersonRSVP = z.infer<typeof PersonRSVPSchema>;
export type RSVPSubmission = z.infer<typeof RSVPSubmissionSchema>;